<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">添加</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">
        <el-form :model="addForm" :rules="rules" ref="addForm">
          <div>
            <el-row>
              <el-col :span="12" class="item">
                <el-form-item label="手机号(登录账号)" required prop="phone">
                  <el-input v-model="addForm.phone" maxlength="11" placeholder="输入手机号"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="item">
                <el-form-item label="登录密码" required  prop="password">
                  <el-input v-model="addForm.password" minlength="6" type="password" placeholder="输入登陆密码" show-password></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12" class="item">
                <el-form-item label="机构名称" required prop="name">
                  <el-input v-model="addForm.name" placeholder="输入机构名称"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="item">
                <el-form-item label="机构类型">
                  <el-select v-model="addForm.type" style="width:100%;">
                    <el-option
                        v-for="item in types"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>


              <el-col :span="12" class="item">
                <el-form-item label="经纬度">
                  <el-input v-model="lonlatstr" disabled placeholder="请抓取经纬度" class="homeAddress">
                    <el-button slot="append" @click="openBaiduMap">抓取</el-button>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="item">
                <el-form-item label="地址">
                  <el-input v-model="addForm.address" placeholder="输入地址"></el-input>
                </el-form-item>
              </el-col>


            </el-row>
          </div>
        </el-form>
      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading" type="primary" @click.native="confirm('addForm')">提交</el-button>
      </div>
    </div>


    <BaiduMap ref="myBaiduMap" v-show="baiduMapShow" v-on:closeMap="closeMap" v-on:setMap="setMap"></BaiduMap>


  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

import BaiduMap from "./BaiduMap";

export default {
  name: 'Add',
  props: [],
  data() {
    return {
      baiduMapShow: false,

      loading: false,

      addForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),

        name:'',
        phone:'',
        password: '',
        address:'',
        type:2,
        lon:'',
        lat:'',

      },

      types: [
        {value: 2, label: '家庭养老床位照料机构'},
      ],

      lonlatstr:'',

      rules:{
        phone:[
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: '请输入正确的手机号'
          },
        ],
        name:[
          { required: true, message: '请输入机构名称', trigger: 'blur' },
        ],
        password:[
          { required: true, message: '请输入登录密码', trigger: 'blur' },
        ],
        address:[
          { required: true, message: '请输入地址', trigger: 'blur' },
        ],

      },

    }
  },
  components: {
    BaiduMap
  },
  methods: {
    init(){
      this.$refs.addForm.resetFields();
      this.lonlatstr = '';
    },

    closeSelf() {
      this.$emit("closeAdd");
    },

    openBaiduMap() {
      this.$refs.myBaiduMap.init();
      this.baiduMapShow = true;
    },
    closeMap() {
      this.baiduMapShow = false
    },
    setMap(info) {
      this.baiduMapShow = false

      let gcLonLat = this.bMapTransWXMap(info.lng,info.lat);
      this.addForm.lon = gcLonLat[0];
      this.addForm.lat = gcLonLat[1];

      this.lonlatstr = info.lng +","+info.lat;

    },

    confirm(addForm){
      this.$refs[addForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          return false;
        }
      })
    },

    addSubmit(){

      if(this.addForm.lon == ''){
        this.$message({type: 'info', message: '请抓取经纬度'});
        return;
      }

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Institution/AddByGov",
        data: this.addForm
      }).then((response) => {
        this.loading = false;
        if (response.data.error == 0) {
          this.$emit("closeAdd");
          this.$emit("getList");
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      })
    },


    // GCJ-02 to BD-09
    bd_encrypta(gg_lon, gg_lat) {
      var X_PI = Math.PI * 3000.0 / 180.0;
      var x = gg_lon, y = gg_lat;
      var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * X_PI);
      var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * X_PI);
      var bd_lon = z * Math.cos(theta) + 0.0065;
      var bd_lat = z * Math.sin(theta) + 0.006;
      return [bd_lon, bd_lat]
    },

    // BD-09 to GCJ-02
    bMapTransWXMap(lng, lat) {
      let x_pi = 3.14159265358979324 * 3000.0 / 180.0;
      let x = lng - 0.0065;
      let y = lat - 0.006;
      let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
      let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
      let lngs = z * Math.cos(theta);
      let lats = z * Math.sin(theta);
      return [lngs, lats]
    },


  }
}
</script>

